import { ReactNode } from 'react';

interface FieldProps {
  label: string;
  hint?: string;
  children: ReactNode;
}

const Field = ({ label, hint, children }: FieldProps) => (
  <div>
    <div className="mb-2">
      <span className="text-sm font-semibold text-neutral-80">{label}</span>
      {hint && <span className="ml-1.5 text-xs text-neutral-50">{hint}</span>}
    </div>
    {children}
  </div>
);

export default Field;
